import { isApproverOrHigherRole } from '@ankor-io/common/domain/iam/account'

import { useUserContext } from '@/providers/user/useUserContext'
import { Button } from '@/ui-components/Button'
import { Heading } from '@/ui-components/Heading'
import { ChartersTable } from '@/views/Charters/ChartersTable'

export const Charters = () => {
  const { activeOrganizationRole } = useUserContext()

  return (
    <div className="space-y-6">
      <div className="flex md:items-center justify-between gap-2 flex-col md:flex-row">
        <Heading level={3}>Charters</Heading>

        {isApproverOrHigherRole(activeOrganizationRole) && (
          <Button
            className="w-full md:w-auto"
            color="primary"
            to="/charters/new"
            data-testid="open-new-charter-modal"
          >
            New Charter
          </Button>
        )}
      </div>

      <ChartersTable />
    </div>
  )
}

export default Charters
